import React from 'react'

export const TrustBox = () => {
    // Create a reference to the <div> element which will represent the TrustBox
    const ref = React.useRef(null)
    React.useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.

        if ((window as any).Trustpilot) {
            ;(window as any).Trustpilot.loadFromElement(ref.current, true)
        }
    }, [])
    return (
        <div className="carousel">
            <div
                ref={ref} // We need a reference to this element to load the TrustBox in the effect.
                className="trustpilot-widget"
                data-locale="en-US"
                data-template-id="53aa8912dec7e10d38f59f36"
                data-businessunit-id="614dd92352cec5001dd32440"
                data-style-height="100%"
                data-style-width="100%"
                data-theme="light"
                data-text-color="#ffffff"
                data-stars="4,5"
                data-review-languages="en"
                data-font-family="Rubik"
            ></div>
        </div>
    )
}
